import React from "react";
import { Link as RouterLink } from "react-router";
import { Heading, Link } from "@flixbus/honeycomb-react";
import { Icon, IconInfoSolid } from "@flixbus/honeycomb-icons-react";
import { routePaths } from "@/constants/routePaths";
import styles from "./AuthenticatedNotFound.module.scss";

const AuthenticatedNotFound: React.FC = () => (
  <main className={styles.container} id="main-content">
    <Icon InlineIcon={IconInfoSolid} size={6} extraClasses={styles.icon} />
    <Heading size={4} flushSpace>
      Page not found
    </Heading>
    <Link RouterLink={RouterLink} to={routePaths.calculations}>
      Back to calculations
    </Link>
  </main>
);

export default React.memo(AuthenticatedNotFound);
